/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_SentInputs */

const th_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งคำเชิญแล้ว`)
};

const en_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation sent.`)
};

const ja_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待を送信しました。`)
};

const zh_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请已发送。`)
};

const es_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitación enviada.`)
};

const pt_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convite enviado.`)
};

const id_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undangan terkirim.`)
};

const fr_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation envoyée.`)
};

const tl_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naipadala ang paanyaya.`)
};

const vi_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi lời mời.`)
};

const ko_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대를 보냈습니다.`)
};

const de_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladung gesendet.`)
};

const ru_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашение отправлено.`)
};

const tr_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet gönderildi.`)
};

const it_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invito inviato.`)
};

const pl_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaproszenie wysłane.`)
};

const uk_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрошення надіслано.`)
};

const hi_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निमंत्रण भेज दिया गया।`)
};

const ar_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أُرسلت الدعوة.`)
};

const ms_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemputan dihantar.`)
};

const bn_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমন্ত্রণ পাঠানো হয়েছে।`)
};

const zh_tw2_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請已寄出。`)
};

const zh_hk2_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請已寄出。`)
};

const ur_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوت بھیج دی گئی۔`)
};

const fa_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوت فرستاده شد.`)
};

const sw_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwaliko umetumwa.`)
};

const nl_invite_sent = /** @type {(inputs: Invite_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodiging verstuurd.`)
};

/**
* | output |
* | --- |
* | "Invitation sent." |
*
* @param {Invite_SentInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_sent = /** @type {((inputs?: Invite_SentInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_SentInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invite_sent(inputs)
	if (locale === "ja") return ja_invite_sent(inputs)
	if (locale === "zh") return zh_invite_sent(inputs)
	if (locale === "es") return es_invite_sent(inputs)
	if (locale === "pt") return pt_invite_sent(inputs)
	if (locale === "id") return id_invite_sent(inputs)
	if (locale === "fr") return fr_invite_sent(inputs)
	if (locale === "tl") return tl_invite_sent(inputs)
	if (locale === "vi") return vi_invite_sent(inputs)
	if (locale === "ko") return ko_invite_sent(inputs)
	if (locale === "de") return de_invite_sent(inputs)
	if (locale === "ru") return ru_invite_sent(inputs)
	if (locale === "tr") return tr_invite_sent(inputs)
	if (locale === "it") return it_invite_sent(inputs)
	if (locale === "pl") return pl_invite_sent(inputs)
	if (locale === "uk") return uk_invite_sent(inputs)
	if (locale === "hi") return hi_invite_sent(inputs)
	if (locale === "ar") return ar_invite_sent(inputs)
	if (locale === "ms") return ms_invite_sent(inputs)
	if (locale === "bn") return bn_invite_sent(inputs)
	if (locale === "zh-TW") return zh_tw2_invite_sent(inputs)
	if (locale === "zh-HK") return zh_hk2_invite_sent(inputs)
	if (locale === "ur") return ur_invite_sent(inputs)
	if (locale === "fa") return fa_invite_sent(inputs)
	if (locale === "sw") return sw_invite_sent(inputs)
	if (locale === "nl") return nl_invite_sent(inputs)
	return en_invite_sent(inputs)
});